import styled from 'styled-components';

export const GameLogo = styled.img`
  cursor: pointer;
  vertical-align: middle;
  height: 50px;
  margin-left: 20px;
  margin-right: 20px;

  @media (max-width: 480px) {
    height: 32px;
    margin-left: 8px;
    margin-right: 8px;
  }
`;
